import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-nav" }
const _hoisted_2 = { class: "nav-box" }
const _hoisted_3 = { class: "nav-logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "nav-menu" }

import { ref, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { getHost } from '@/utils/domain.js';
  import { getSiteHostInfo } from '@/apis/modules/login/login';

  // const router = useRouter();

  interface NavItem {
    path: string;
    title: string;
    // 新增匹配规则
    matchPattern?: string[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'MyNav',
  setup(__props) {

  const route = useRoute();
  const logoUrl = ref('');

  const navItems: NavItem[] = [
    { path: '/home', title: '首页' },
    {
      path: '/domesticLogistics',
      title: '国内物流',
      // 匹配所有国内物流相关子路由
      matchPattern: [
        '/domesticLogistics',
        '/logisticParticulars',
        '/logisticOrder'
      ]
    },
    { path: '/internationalLogistics', title: '国际物流' },
    { path: '/factoryView/index', title: '工厂企业' },
    { path: '/freightSource', title: '货源信息' },
    { path: '/vehicleSource', title: '车源信息' },
    // { path: '/logisticsPark', title: '物流园区' },
    { path: '/logisticsInformation', title: '物流资讯' },
    { path: '/platformIntroduction', title: '平台简介' },
  ];

  // 获取站点logo
  const fetchSiteLogo = async () => {
    try {
      // 设置默认logo
      logoUrl.value = require('@/assets/zhultLogo.png');
      const host = getHost();
      const res = await getSiteHostInfo({ adHost: host });
      if (res && res.statusCode === 20000 && res.data && res.data.siteLogo) {
        logoUrl.value = res.data.siteLogo;
        console.log('站点logo:', res.data.siteLogo);
      }
    } catch (error) {
      console.error('获取站点logo失败:', error);
      if (!logoUrl.value) {
        logoUrl.value = require('@/assets/zhultLogo.png');
      }
    }
  };

  onMounted(() => {
    fetchSiteLogo();
  });

  const isActive = (item: NavItem) => {
    // 调试输出
    console.log(`Checking ${item.title} (${item.path}) against ${route.path}`)

    // 优先使用匹配规则
    if (item.matchPattern) {
      const currentPath = route.path.replace(/\/$/, '')
      return item.matchPattern.some(pattern => {
        const normalizedPattern = pattern.replace(/\/$/, '')
        return currentPath.startsWith(normalizedPattern)
      })
    }

    // 普通路径匹配
    return route.path === item.path;
  };

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: logoUrl.value,
          alt: "助力通logo",
          class: "logo-img"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
          return _createVNode(_component_router_link, {
            to: item.path,
            class: "menu-item",
            "active-class": "active-item",
            key: item.path
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        }), 64))
      ])
    ])
  ]))
}
}

})